import React, { createContext, useCallback, useState } from 'react';

export const ErrorContext = createContext({
  errors: [],
  addError: () => {},
  removeError: () => {},
  clearErrors: () => {},
});

let idCounter = 0;

export const ErrorProvider = ({ children, max = 5, ttl = 10000 }) => {
  const [errors, setErrors] = useState([]);

  const removeError = useCallback((id) => {
    setErrors((list) => list.filter((e) => e.id !== id));
  }, []);

  const addError = useCallback(
    (err) => {
      setErrors((list) => {
        const newItem = { ...err, id: ++idCounter, ts: Date.now() };
        const next = [...list, newItem].slice(-max);
        return next;
      });
    },
    [max]
  );

  const clearErrors = useCallback(() => setErrors([]), []);

  // TTL cleanup effect (simple interval)
  React.useEffect(() => {
    const interval = setInterval(() => {
      setErrors((list) => list.filter((e) => Date.now() - e.ts < ttl));
    }, 2000);
    return () => clearInterval(interval);
  }, [ttl]);

  return (
    <ErrorContext.Provider
      value={{ errors, addError, removeError, clearErrors }}
    >
      {children}
    </ErrorContext.Provider>
  );
};
